import ListCardEducation from './listCardEducation'
export default ListCardEducation
